export default __webpack_public_path__ + "static/board2-cc2592f5966aad6cc1007357374a7bb4.png";